import DefaultOrdersConfig from '../default/orders-config'
import CyesaOrdersConfig from '../cyesa/orders-config'
import webshopName from '../common/webshop-name'

const orderModule = webshopName === 'cyesa-com' ? CyesaOrdersConfig : DefaultOrdersConfig

export default orderModule
